export const DEFAULT_RISK_PERCENT = 0.5;
export const RISK_PERCENT_STORAGE_KEY = 'ntb:conceptgate:defaultRiskPercent';

export const getStoredRiskPercent = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_RISK_PERCENT;
  }

  const storedValue = window.localStorage.getItem(RISK_PERCENT_STORAGE_KEY);
  const parsedValue = parseFloat(storedValue);

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return DEFAULT_RISK_PERCENT;
  }

  return parsedValue;
};

export const persistRiskPercent = (value) => {
  if (typeof window === 'undefined') {
    return;
  }

  const parsedValue = parseFloat(value);

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return;
  }

  window.localStorage.setItem(RISK_PERCENT_STORAGE_KEY, parsedValue.toString());
};
